// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import FraisscolariteProfileLayout from './FraisscolariteProfileLayout';

import FraisscolariteService from '../../services/FraisscolariteService';

const DeleteFraisscolarite = () => {
	const [fraisscolarite, setStudent] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([FraisscolariteService.getFraisscolarite(id)]).then(([fraisscolariteData]) => {
			setStudent(fraisscolariteData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the FraisscolariteService to delete the fraisscolarite
			await FraisscolariteService.deleteFraisscolarite(id);

			// Redirect the user to the list of fraisscolarites
			navigate('/finances/scolarite');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations de la Scolarite",
				error
			);
		}
	};

	return (
		<FraisscolariteProfileLayout>
			{fraisscolarite && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{fraisscolarite.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cette scolarite.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez cette scolarite, toutes les données la concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer la scolarite
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</FraisscolariteProfileLayout>
	);
};

export default DeleteFraisscolarite;
